import EmailAlertsTextContent from './EmailAlertsTextContent';

export default EmailAlertsTextContent;
